<div fxLayout="column">
    <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start" class="bold">
        <div fxFlex="50" fxLayout="row" fxLayoutAlign="start start">
            <span fxFlex="30">Vendor Name</span>
            <span fxFlex="33">Invoice Number</span>
            <span fxFlex="33">Description</span>
        </div>
        <div fxFlex="50" fxLayout="row" fxLayoutAlign="end start" class="numeric">
            <span fxFlex="25">Invoice Date</span>
            <span fxFlex="25">Post Date</span>
            <span fxFlex="25">Invoice Due Date</span>
            <span fxFlex="25">Invoice Amount</span>
        </div>
    </div>
    <mat-divider class="mt10"></mat-divider>

    <div *ngFor="let vendor of getVendors()" fxLayout="column" class="vendor">

        <div *ngFor="let invoice of getInvoices(vendor); first as isFirstInvoice; last as isLastInvoice" fxFlex="auto" fxLayout="column" class="mt10 invoice">

            <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">

                <div fxFlex="50" fxLayout="row" fxLayoutAlign="start start">
                    <span *ngIf="isFirstInvoice" fxFlex="30">{{vendor}}</span>
                    <span *ngIf="!isFirstInvoice" fxFlex="30"></span>
                    <span fxFlex="33">{{invoice.Number}}</span>
                    <span fxFlex="33">{{invoice.Description}}</span>
                </div>

                <div fxFlex="50" fxLayout="row" fxLayoutAlign="end start" class="numeric">
                    <span fxFlex="25">{{invoice.Date | date:'M/d/yyyy'}}</span>
                    <span fxFlex="25">{{invoice.PostDate | date:'M/d/yyyy'}}</span>
                    <span fxFlex="25">{{invoice.DueDate | date:'M/d/yyyy'}}</span>
                    <span fxFlex="25">{{invoice.Amount | currency}}</span>
                </div>
            </div>

            <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">
                <div class="mt10" fxFlex="50" fxLayout="row" fxLayoutAlign="start start">
                    <span fxFlex="30">Purchase Order Number</span>
                    <span fxFlex="auto">Bank</span>
                </div>
                <div fxFlex="auto"></div>
            </div>

            <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">
                <div fxFlex="50" fxLayout="row" fxLayoutAlign="start start">
                    <span *ngIf="isFirstInvoice" fxFlex="30">{{invoice.PurchaseOrderNumber}}</span>
                    <span fxFlex="auto">{{invoice.BankCodeDescription}}</span>
                </div>
                <div fxFlex="auto"></div>
            </div>

            <div class="mt20" fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">
                <div fxFlex="50" fxLayout="row" fxLayoutAlign="start start">
                    <span fxFlex="20" fxFlexOffset="10">Status</span>
                    <span fxFlex="33">Units</span>
                    <span fxFlex="33">Item Description</span>
                </div>
                <div fxFlex="50" fxLayout="row" fxLayoutAlign="end start" class="numeric">
                    <span fxFlex="25">Account</span>
                    <span fxFlex="25">{{ProjectAccountName}}</span>
                    <span fxFlex="15">Tax</span>
                    <span fxFlex="15">Shipping</span>
                    <span fxFlex="20">Total</span>
                </div>
            </div>

            <div *ngFor="let item of invoice.Items; last as isLastItem" fxFlex="auto" fxLayout="column" class="invoiceItem">

                <div class="mt10" fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">

                    <div fxFlex="50" fxLayout="row" fxLayoutAlign="start start">
                        <span fxFlex="20" fxFlexOffset="10">{{item.Status}}</span>
                        <span fxFlex="33">{{item.Units}}</span>
                        <span fxFlex="33">{{item.Description}}</span>
                    </div>

                    <div fxFlex="50" fxLayout="row" fxLayoutAlign="end start" class="numeric">
                        <span fxFlex="25">{{item.GlAccountNumber}}</span>
                        <span fxFlex="25">{{item.ProjectAccountNumber}}</span>
                        <span fxFlex="15">{{item.SalesTax | currency}}</span>
                        <span fxFlex="15">{{item.Shipping | currency}}</span>
                        <span fxFlex="20">{{item.Amount | currency}}</span>
                    </div>
                </div>

                <mat-divider *ngIf="$isLastItem && !isLastInvoice" class="mt10"></mat-divider>

            </div>

        </div>

        <mat-divider class="mt10"></mat-divider>
    </div>

    <div fxFlex="auto" fxLayout="column" class="summary">
        <h3>PO Receipt Invoice Summary</h3>
        <div fxLayout="column" class="center">
            <div fxFlex="50" fxLayout="row">
                <span fxFlex="30"><strong>Invoice Number</strong></span>
                <span fxFlex="50"><strong>Description</strong></span>
                <span fxFlex="20" class="numeric"><strong>Invoice Total</strong></span>
            </div>

            <div *ngFor="let invoice of detail" fxLayout="row" fxLayoutAlign="space-between start">
                <span fxFlex="30">{{invoice.Number}}</span>
                <span fxFlex="50">{{invoice.Description}}</span>
                <span fxFlex="20" class="numeric">{{invoice.Amount | currency}}</span>
            </div>

            <mat-divider></mat-divider>
        </div>

        <div class="grandTotal">
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <span fxFlex="30"><strong>Total</strong></span>
                <span fxFlex="20" class="numeric"></span>
                <span fxFlex="50" class="numeric">{{grandTotal | currency}}</span>
            </div>
        </div>
    </div>
</div>